module["exports"] = [
  "Sr.",
  "Sra.",
  "Sta."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es/name/prefix.js
// module id = 775
// module chunks = 0